import EndUserConstants from 'constants/EndUserConstants'
import { captureException, captureResponseException } from 'utils/SentryHelpers'
import store from 'containers/store'
import * as DemoConstants from 'app/modules/reports/demodata'
import * as GateSelectors from 'app/modules/gates/selectors'

const {
  FETCH_ORG_END_USER_COUNT_DONE,
  FETCH_ORG_END_USER_COUNT_HISTORY_DONE
} = require('constants/ActionConstants').default

const NotFoundUser = {
  timeZone: null,
  locale: null,
  raw: null,
  name: 'Deleted User',
  type: 'END_USER',
  attributes: {}
}

const EndUserQueries = Marty.createQueries({
  id: 'EndUserQueries',

  fetchEndUser(endUserId) {
    const endUserPromise = this.app.sources.EndUserAPI.fetchEndUser(endUserId)

    endUserPromise.then(res => {
      if ((res.status === 200) || 404) {
        const found = res.status === 200
        return this.dispatch(EndUserConstants.END_USER_FETCH_DONE, endUserId, found ? res.body : _.extend({ id: endUserId }, NotFoundUser))
      } else {
        captureResponseException(res)
        return this.dispatch(EndUserConstants.END_USER_FETCH_FAILED, endUserId, res)
      }
    })

    return endUserPromise.catch(error => {
      captureException(error)
      return this.dispatch(EndUserConstants.END_USER_FETCH_FAILED, endUserId, error)
    })
  },

  fetchEndUsers(endUserIds) {
    const promise = this.app.sources.EndUserAPI.fetchEndUsers(endUserIds)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(EndUserConstants.END_USERS_FETCH_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(EndUserConstants.END_USERS_FETCH_FAILED, endUserIds, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(EndUserConstants.END_USERS_FETCH_FAILED, endUserIds, error)
    })
  },

  fetchEndUserSegments(endUserId, orgId) {
    const promise = this.app.sources.EndUserAPI.fetchEndUserSegments(endUserId, orgId)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(EndUserConstants.END_USER_SEGMENTS_FETCH_DONE, endUserId, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(EndUserConstants.END_USER_SEGMENTS_FETCH_FAILED, endUserId, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(EndUserConstants.END_USER_SEGMENTS_FETCH_FAILED, endUserId, error)
    })
  },

  fetchOrgEndUserCount(orgId, startDate) {
    const promise = this.app.sources.EndUserAPI.fetchOrgEndUserCount(orgId, startDate)
    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(FETCH_ORG_END_USER_COUNT_DONE, res.body, startDate)
      } else {
        return captureResponseException(res)
      }
    })

    return promise.catch(error => captureException(error))
  },

  fetchOrgEndUserCountHistory(orgId, startDate, endDate) {
    const promise = this.app.sources.EndUserAPI.fetchOrgEndUserCountHistory(orgId, startDate, endDate)
    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(FETCH_ORG_END_USER_COUNT_HISTORY_DONE, res.body)
      } else {
        return captureResponseException(res)
      }
    })

    return promise.catch(error => captureException(error))
  },

  fetchEndUserAttributesForOrg(orgId) {
    const promise = this.app.sources.EndUserAPI.fetchEndUserAttributesForOrg(orgId)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(EndUserConstants.END_USER_ATTRIBUTES_FETCH_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(EndUserConstants.END_USER_ATTRIBUTES_FETCH_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(EndUserConstants.END_USER_ATTRIBUTES_FETCH_FAILED, error)
    })
  },

  createEndUserForOrgId(endUser, orgId) {
    const promise = this.app.sources.EndUserAPI.createEndUserForOrgId(endUser, orgId)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(EndUserConstants.CREATE_USER_FOR_ORG_ID_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(EndUserConstants.CREATE_USER_FOR_ORG_ID_FAILED, endUser, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(EndUserConstants.CREATE_USER_FOR_ORG_ID_FAILED, endUser, error)
    })
  },

  searchEndUser(orgId, query) {
    const promise = this.app.sources.EndUserAPI.searchEndUser(orgId, query)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(EndUserConstants.SEARCH_END_USER_DONE, orgId, query, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(EndUserConstants.SEARCH_END_USER_FAILED, orgId, query, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(EndUserConstants.SEARCH_END_USER_FAILED, orgId, query, error)
    })
  },

  elasticSearchEndUser(orgId, query, from = 0, size = 10, sortField, sortDirection) {

    if (GateSelectors.hasDemoOrg(store.getState())) {
      return Promise.resolve(this.dispatch(EndUserConstants.ELASTIC_SEARCH_END_USER_DONE, orgId, query, from, size, sortField, sortDirection, DemoConstants.demoContacts))
    }

    const promise = this.app.sources.EndUserAPI.elasticSearchEndUser(orgId, query, from, size, sortField, sortDirection)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(EndUserConstants.ELASTIC_SEARCH_END_USER_DONE, orgId, query, from, size, sortField, sortDirection, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(EndUserConstants.ELASTIC_SEARCH_END_USER_FAILED, orgId, query, from, size, sortField, sortDirection, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(EndUserConstants.ELASTIC_SEARCH_END_USER_FAILED, orgId, query, from, size, sortField, sortDirection, error)
    })
  },

  deleteByQuery(orgId, query) {
    this.dispatch(EndUserConstants.DELETE_END_USERS_BULK_STARTING)
    return this.app.sources.EndUserAPI.deleteByQuery(orgId, query)
      .then(res => {
        if (res.status === 200) {
          this.app.actions.NotificationActions.pushNotification({
            content: 'Your contacts have been successfully deleted.',
            variant: 'green',
          })
          return this.dispatch(EndUserConstants.DELETE_END_USERS_BULK_DONE, query)
        } else {
          captureResponseException(res)
          return this.dispatch(EndUserConstants.DELETE_END_USERS_BULK_FAILED, query)
        }
      })
  },

  deleteBySegment(orgId, segmentId) {
    this.dispatch(EndUserConstants.DELETE_END_USERS_BULK_STARTING)
    return this.app.sources.EndUserAPI.deleteBySegment(orgId, segmentId)
      .then(res => {
        if (res.status === 200) {
          this.app.actions.NotificationActions.pushNotification({
            content: 'Your contacts have been successfully deleted.',
            variant: 'green',
          })
          return this.dispatch(EndUserConstants.DELETE_END_USERS_BULK_DONE, segmentId)
        } else {
          captureResponseException(res)
          return this.dispatch(EndUserConstants.DELETE_END_USERS_BULK_FAILED, segmentId)
        }
      })
  },

  deleteEndUsers(endUserIds) {
    const promises = _.map(endUserIds, endUserId => {
      return this.app.sources.EndUserAPI.updateEndUser(endUserId, { status: 'ARCHIVED' })
    })
    const promise = Promise.all(promises)
    promise.then(responses => {
      if (_.every(responses, response => response.status === 200)) {
        return this.dispatch(EndUserConstants.DELETE_END_USERS_DONE, endUserIds)
      } else {
        return this.dispatch(EndUserConstants.DELETE_END_USERS_FAILED, endUserIds)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(EndUserConstants.DELETE_END_USERS_FAILED, endUserIds)
    })
  },

  updateEndUser(endUserId, endUserParams, accessToken) {
    const promise = this.app.sources.EndUserAPI.updateEndUser(endUserId, endUserParams, accessToken)

    this.dispatch(EndUserConstants.END_USER_UPDATE_STARTING, endUserId)
    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(EndUserConstants.END_USER_UPDATE_DONE, res.body, endUserParams)
      } else {
        captureResponseException(res)
        return this.dispatch(EndUserConstants.END_USER_UPDATE_FAILED, endUserId, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(EndUserConstants.END_USER_UPDATE_FAILED, endUserId, error)
    })
  },

  unsubscribeEndUser(endUserId, campaignId, reason) {
    this.dispatch(EndUserConstants.END_USER_UNSUBSCRIBE_STARTING, endUserId)
    return this.app.sources.EndUserAPI.unsubscribeEndUser(endUserId, campaignId, reason).then(res => {
      if ((res.status >= 200) && (res.status < 300)) {
        return this.dispatch(EndUserConstants.END_USER_UNSUBSCRIBE_DONE, endUserId)
      } else {
        captureResponseException(res)
        return this.dispatch(EndUserConstants.END_USER_UNSUBSCRIBE_FAILED, res)
      }
    })
  }
})

export default EndUserQueries



// WEBPACK FOOTER //
// ./src/scripts/queries/EndUserQueries.js